<template>
  <div class="modal fade"
       id="modalVerDocumentoDictamen"
       tabindex="-1"
       role="dialog"
       aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" role="document" style="max-width: 85vw">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Dictamen <template v-if="dictamen">{{dictamen.Expediente.Consecutivo}} {{dictamen.Expediente.AreaDBPJ.Abreviatura}}</template></h5>
          <button type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <br />          
          <div class="row">
            <div class="col-12">
              <div class="col-12" v-show="rutaDictamen">
                <PDFDocument :url="rutaDictamen" :height="'80vh'" :key="pdfkey"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'
  export default {
    data() {
      return {
        rutaDictamen: "",
        pdfkey: 0,
        dictamen: null
      }
    },
    props: {
      parametros: Object
    },
    components: {
      PDFDocument
    },
    methods: {
      getDictamen: function () {
        var peticion = {
          "esPrueba": false,
          "DictamenId": this.parametros.dictamenId
        };
        console.log(peticion)
        
        axios.post(api.conexion + api.SIPSIC.funciones.GetDictamen, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            console.log(response)
            this.dictamen = response.data.Dictamen
            this.rutaDictamen = response.data.Dictamen.DictamenRuta
            this.pdfkey++;            
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      }
    }, mounted() {
      this.$forceUpdate();
      console.log(this.parametros.dictamenId)
      if (this.parametros.dictamenId)
      this.getDictamen();
    },
    watch: {
      // whenever question changes, this function will run
      parametros: function (nuevosParametros, viejosParametros) {
        console.log(nuevosParametros)
        console.log(viejosParametros)
      }
    },
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }

  .padding-div-low {
    padding-top: 40px;
  }

  .alinear_izq {
    float: left;
  }

  .alinear_der {
    float: right;
  }

  .contenedor-puntero {
    background: #212529;
    border-radius: 2px;
    padding: 10px;
    border: 1px solid white;
    margin-bottom: 1.5em;
  }
</style>
<style>
  .padding-div-low {
    padding-top: 40px;
  }

  #calendario_agendar_siccij .fc-view-container {
    background-color: transparent !important;
    color: #343a40 !important;
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-view table {
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-axis {
    background-color: #504f54;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
  }

  #calendario_agendar_siccij .fc-day-header {
    background-color: #212529 !important;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
    padding: .75rem !important;
  }

  #calendario_agendar_siccij .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    text-shadow: none !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  #calendario_agendar_siccij .fc-state-active {
    background-color: rgb(174, 174, 174) !important;
  }

  #calendario_agendar_siccij .fc-button:focus {
    outline: none !important;
  }

  #calendario_agendar_siccij .fc-today {
    background-color: rgba(242,242,242,0.5) !important;
    color: white !important;
  }

  #calendario_agendar_siccij .fc-day-number {
    color: white !important;
  }

  #calendario_agendar_siccij .fc-event {
    background-color: #212529;
    border-color: #32383e !important;
    color: white !important;
    padding: 0 .375rem !important;
    font-size: 1.0em;
    border-radius: .25rem !important;
    width: 80% !important;
    text-align: center !important;
    margin: auto !important;
  }

  tr {
  }
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/ControlDeDictamenes/VerDocumentoDictamen.vue